import type { Rotina } from '~/types/pagesMenu';

const nomesRotinasRecepcao = {
	PLANILHA_CEGA: "Conferência de planilha cega",
	PLANILHA_CEGA_UMA: "Conferência de planilha cega (U.M.A)"
} as const;
export type RotinasRecepcao = typeof nomesRotinasRecepcao[keyof typeof nomesRotinasRecepcao];

const rotinasRecepcao: Rotina[] = [
	{
		categoria: "Recepção",
		label: nomesRotinasRecepcao.PLANILHA_CEGA,
		nome: "mni_ColetorDadosConferenciaPlanilhaCega",
		rotina: "PROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR",
		tela: "B311",
		disponivel: true
	},
	{
		categoria: "Recepção",
		label: nomesRotinasRecepcao.PLANILHA_CEGA_UMA,
		nome: "mni_Conferencia_Cega_UMA_Palete_Conferido",
		rotina: "PROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR",
		tela: "B315",
		disponivel: true
	}
];

export { rotinasRecepcao };
